import useAggregatorPayloadTab from './hooks';
import styles from './AggregatorPayloadTab.module.scss';

const AggregatorPayloadTab = () => {
  const aggregatorPayloadInfo = useAggregatorPayloadTab();

  const renderAggregatorPayloadInfo = () => (
    <div>
      <pre>{aggregatorPayloadInfo}</pre>
    </div>
  );

  return <div className={styles.aggregatorPayloadTab}>{renderAggregatorPayloadInfo()}</div>;
};

export default AggregatorPayloadTab;
